const demographySegmentMap = {
    KVA: {
        // Age
        sv4932929: 1,
        sv499ziag: 2,
        sv5aguq3o: 3,
        sv5ai5w5o: 4,
        sv5anzxd2: 5,
        sv5arlrqq: 6,
    },
    KVB: {
        // Gender
        sv49uxkpe: 1,
        sv49pfngj: 2,
    },
    KVC: {
        // Household Income
        sv5cdvuyv: 1,
        sv5cj0zqj: 2,
        sv5cm7wea: 3,
        tx816sz7y: 4,
    },
    KVD: {
        // Professional Position
        sv5icl6xf: 1,
        sv5ifx7pw: 2,
        sv5ik94kw: 3,
        sv5iqf6q5: 4,
        sv5iut80u: 5,
    },
    KVE: {
        // Investor Profile
        sv5g6b89b: 1,
        sv5g4e4h9: 2,
    },
    KVF: {
        // Employer Type
        sv5hb6qhq: 1,
        sv5g9kpyo: 2,
    },
    KVG: {
        // House Type
        sv5gjt01m: 1,
        sv5ggfk56: 2,
        sv5gc26an: 3,
    },
    KVH: {
        // Company Size
        sv5ejbz38: 1,
        sv5efqkio: 2,
        sv5ec7s9o: 3,
        sv5d93q84: 4,
        sv5d62z5q: 5,
        sv5d3au0d: 6,
    },
    KVI: {
        // Education Level
        sv5a3rffu: 1,
        sv5bed6pm: 2,
        sv5bhelkg: 3,
        sv5bry7os: 4,
    },
    KVJ: {
        // Housing Form
        sv5ftye7l: 1,
        sv5fw803r: 2,
    },
    KVK: {
        // Entrepreneurship
        sv5dpy7b1: 1,
        sv5dtlezi: 2,
    },
    KVL: {
        // Living Situation
        sv5dhcmyf: 1,
        sv5devf1n: 2,
        sv5dcaorf: 3,
        sv5c7pq63: 4,
        sv5c3wa1z: 5,
    },
    KVTA: {
        // Age
        vay3tbjfn: 1,
        vay3u47v4: 2,
        vay3w42fs: 3,
        vay3yz41h: 4,
        vay308b8v: 5,
        vay321aam: 6,
    },
    KVTB: {
        // Gender
        vay3qyv82: 1,
        vay3o48cs: 2,
    },
    KVTC: {
        // Household Income
        vay4fg91x: 1,
        vay4hrdbi: 2,
        vay4ju1b7: 3,
        vay4mfe61: 4,
    },
    KVTD: {
        // Professional Position
        vay57olex: 1,
        vay6ewof6: 2,
        vay6gxza7: 3,
        vay6jglx4: 4,
        vay6l9fiv: 5,
    },
    KVTF: {
        // Employer Type
        vay54vqec: 1,
        vay53e6a6: 2,
    },
    KVTG: {
        // House Type
        vay5vq80l: 1,
        vay5tn3l5: 2,
        vay5r4ynk: 3,
    },
    KVTH: {
        // Company Size
        vay5i35j2: 1,
        vay5hj7wy: 2,
        vay5fxyfd: 3,
        vay5dqmvk: 4,
        vay5b2e1l: 5,
        vay5ai5wn: 6,
    },
    KVTI: {
        // Education Level
        vay37rj8n: 1,
        vay39k1jp: 2,
        vay4bbbqd: 3,
        vay4dgoiv: 4,
    },
    KVTJ: {
        // Housing Form
        vay5o71ji: 1,
        vay5m1qcy: 2,
    },
    KVTK: {
        // Entrepreneurship
        vay43cy5f: 1,
        vay46dw0y: 2,
    },
    KVTL: {
        // Living Situation
        vay4zza39: 1,
        vay4yc25x: 2,
        vay4wbyvz: 3,
        vay4thkx9: 4,
    },
};
export default demographySegmentMap;
//# sourceMappingURL=segment-map.js.map